<template>
  <div>
    <b-form-checkbox-group
      stacked
      v-model="value"
      class="mb-3"
      :options="question.options"
      text-field="label"
      value-field="label"
      size="lg"
    ></b-form-checkbox-group>
    <b-button block variant="primary" @click="next()">Next</b-button>
  </div>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    next() {
      const answer = {
        value: [],
        score: 0,
        jumpTo: null,
      };
      this.value.forEach((option) => {
        const selectedOption = this.question.options.filter((o) => (o.label === option))[0];
        answer.value.push(selectedOption.label);
        answer.score += (selectedOption.score || 0);
        answer.jumpTo = selectedOption.jumpTo;
      });
      this.$emit('answered', answer);
    },
  },
};
</script>
